import { render, staticRenderFns } from "./inductrialInjuryPrevention.vue?vue&type=template&id=018ca127&scoped=true"
import script from "./inductrialInjuryPrevention.vue?vue&type=script&lang=js"
export * from "./inductrialInjuryPrevention.vue?vue&type=script&lang=js"
import style0 from "./inductrialInjuryPrevention.vue?vue&type=style&index=0&id=018ca127&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018ca127",
  null
  
)

export default component.exports